import { Hash } from "lucide-react";
import { fmtTime } from "@/lib/api";
import { groupParagraphs, segText, speakerColor } from "./transcriptUtils";
import { SegmentRow, SegmentSpan } from "./TranscriptText";

export const SectionHeading = ({ section, onSeek, showTs }) => (
  <h3 id={`sec-${section.idx}`} className="mb-2 mt-7 flex scroll-mt-40 items-center gap-2 border-b border-slate-100 pb-2 font-heading text-base font-bold text-slate-900 first:mt-0" data-testid={`transcript-section-${section.idx}`}>
    <Hash size={15} className="text-violet-500" /> {section.title}
    {showTs && <button onClick={() => onSeek?.(section.start)} className="ml-auto font-mono text-xs font-normal text-violet-700 hover:underline">{fmtTime(section.start)}</button>}
  </h3>
);

export const ParagraphView = ({ segs, sections, names, version, current, q, onSeek, showTs }) => (
  <div data-testid="transcript-paragraph-view">
    {groupParagraphs(segs, sections).map((b, i) =>
      b.section ? <SectionHeading key={`s${i}`} section={b.section} onSeek={onSeek} showTs={showTs} /> : (
        <div key={i} className="mb-5" data-testid={`transcript-paragraph-${i}`}>
          <div className="mb-1 flex items-center gap-2">
            <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${speakerColor(b.speaker)}`}>{names[String(b.speaker)] || `Pembicara ${b.speaker}`}</span>
            {showTs && <button onClick={() => onSeek?.(b.start)} className="font-mono text-xs text-violet-700 hover:underline" data-testid={`paragraph-ts-${i}`}>{fmtTime(b.start)}</button>}
          </div>
          <p className="text-[15px] leading-[1.85] text-slate-700">
            {b.segs.map((s) => <SegmentSpan key={s.id} s={s} version={version} current={current} q={q} onSeek={onSeek} />)}
          </p>
        </div>
      )
    )}
  </div>
);

export const SegmentView = ({ segs, sections, q, version, ...p }) => {
  const titles = Object.fromEntries(sections.map((x) => [x.idx, x]));
  const shown = q ? segs.filter((s) => segText(s, version).toLowerCase().includes(q.toLowerCase())) : segs;
  return (
    <div className="space-y-1" data-testid="transcript-segment-view">
      {shown.map((s) => (
        <div key={s.id}>
          {!q && titles[s.idx] && <SectionHeading section={titles[s.idx]} onSeek={p.onSeek} showTs={p.showTs} />}
          <SegmentRow {...p} s={s} q={q} version={version} canEdit={p.canEdit && version === "clean"} />
        </div>
      ))}
    </div>
  );
};

export const SectionNav = ({ sections, onSeek }) => (
  <nav className="slim-scroll max-h-[520px] space-y-0.5 overflow-y-auto" data-testid="transcript-section-nav">
    {sections.map((s) => (
      <button key={s.idx} onClick={() => { document.getElementById(`sec-${s.idx}`)?.scrollIntoView({ behavior: "smooth", block: "start" }); onSeek?.(s.start); }}
        className="flex w-full items-start gap-2 rounded-lg px-2 py-1.5 text-left text-xs text-slate-600 transition-colors hover:bg-violet-50 hover:text-violet-800" data-testid={`section-nav-${s.idx}`}>
        <span className="w-10 shrink-0 font-mono text-violet-600">{fmtTime(s.start)}</span>
        <span className="line-clamp-2 font-medium">{s.title}</span>
      </button>
    ))}
  </nav>
);
